/**
 * Model capability governance endpoints — the catalogue, the evidence, the
 * admissions and the two selection registers (PRD-0243 D-13) — as the one
 * domain the facade serves, assembled from the module that holds each part.
 *
 * The four verbs that dial a provider take a `budgetSeconds` the caller must
 * have read from `listRequestBudgets`, applied as the request's own timeout.
 * Required rather than optional so a fifth such verb cannot inherit a default
 * wait shorter than its own bound, which is what reported three completed
 * conformance walks as server errors (TODO-2053).
 */

import { modelCapabilityConnections } from './modelCapabilityConnections'
import { modelCapabilityDeployments } from './modelCapabilityDeployments'
import { modelCapabilityEvidence } from './modelCapabilityEvidence'
import { modelCapabilitySelection } from './modelCapabilitySelection'

export const modelCapabilities = {
  ...modelCapabilityDeployments,
  ...modelCapabilityConnections,
  ...modelCapabilityEvidence,
  ...modelCapabilitySelection,
}
